import FormattedMessage from 'I18n/components/FormattedMessage';
import { CARD_PAYMENT_TYPE } from '../constants/payments';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import usePaymentHighlightProperties from '../hooks/usePaymentHighlightProperties';
import StoredPMOFTag from './StoredPMOFTag';
import { Text } from 'foundations-components/components/Text';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const commerceHubPaymentMethods = new Set(['ach', 'card', 'sepa', 'pads', 'bacs']);
const PaidWithCommerceHub = ({
  propertyDefinition,
  last4,
  paymentMethodType,
  bankOrIssuer,
  objectId,
  labelColor = 'text-core-subtle'
}) => {
  var _data$crmObject;
  const {
    data
  } = usePaymentHighlightProperties(objectId);
  const isPaymentMethodOnFileActive = data === null || data === void 0 || (_data$crmObject = data.crmObject) === null || _data$crmObject === void 0 ? void 0 : _data$crmObject.isPaymentMethodOnFileActive;
  if (paymentMethodType === CARD_PAYMENT_TYPE) {
    if (isPaymentMethodOnFileActive) {
      return /*#__PURE__*/_jsx(StoredPMOFTag, {
        bankOrIssuer: bankOrIssuer,
        last4: last4,
        labelColor: labelColor
      });
    }
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWith_jsx",
      options: {
        bankOrPaymentMethodType: bankOrIssuer,
        last4,
        labelProps: {
          as: 'span',
          color: labelColor
        },
        valueProps: {
          as: 'span',
          color: 'text-core-default'
        }
      },
      elements: {
        Text
      }
    });
  }
  const paymentMethodOption = propertyDefinition.options.find(option => option.value === paymentMethodType);
  if (paymentMethodOption) {
    if (isPaymentMethodOnFileActive) {
      return /*#__PURE__*/_jsx(StoredPMOFTag, {
        bankOrIssuer: bankOrIssuer,
        last4: last4,
        labelColor: labelColor
      });
    }
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWith_jsx",
      options: {
        bankOrPaymentMethodType: paymentMethodOption.label,
        last4,
        labelProps: {
          as: 'span',
          color: labelColor
        },
        valueProps: {
          as: 'span',
          color: 'text-core-default'
        }
      },
      elements: {
        Text
      }
    });
  }
  return null;
};
const PaidWithExternalProcessor = ({
  objectId,
  propertyDefinition,
  paymentMethodType,
  referenceNumber,
  labelColor = 'text-core-subtle'
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "span",
      color: labelColor,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.paidWith"
      })
    }), /*#__PURE__*/_jsxs(Text, {
      as: "span",
      color: "text-core-default",
      children: [/*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
        objectId: objectId,
        property: propertyDefinition,
        value: paymentMethodType,
        getAdditionalPropertyValue: () => undefined
      }), referenceNumber ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [" ", referenceNumber]
      }) : null]
    })]
  });
};
const PaymentMethodFormatter = ({
  objectId,
  propertyDefinition,
  paymentCreationMethod,
  paymentMethodType,
  referenceNumber,
  last4,
  bankOrIssuer,
  labelColor = 'text-core-subtle'
}) => {
  const isCommerceHubPayment = paymentCreationMethod === 'PAYMENTS_PROCESSOR';
  if (!paymentMethodType) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "formatted-payment-method",
    children: isCommerceHubPayment && commerceHubPaymentMethods.has(paymentMethodType !== null && paymentMethodType !== void 0 ? paymentMethodType : '') ? /*#__PURE__*/_jsx(PaidWithCommerceHub, {
      propertyDefinition: propertyDefinition,
      last4: last4,
      paymentMethodType: paymentMethodType,
      bankOrIssuer: bankOrIssuer,
      objectId: objectId,
      labelColor: labelColor
    }) : /*#__PURE__*/_jsx(PaidWithExternalProcessor, {
      objectId: objectId,
      propertyDefinition: propertyDefinition,
      paymentMethodType: paymentMethodType,
      referenceNumber: referenceNumber,
      labelColor: labelColor
    })
  });
};
export default PaymentMethodFormatter;